var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.94,
    height: 21.94,
    viewBox: "0 0 21.94 21.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    "data-name": "Icon awesome-plus",
    d: "M20.373,10.869H13.321V3.817A1.567,1.567,0,0,0,11.754,2.25H10.186A1.567,1.567,0,0,0,8.619,3.817v7.052H1.567A1.567,1.567,0,0,0,0,12.436V14a1.567,1.567,0,0,0,1.567,1.567H8.619v7.052a1.567,1.567,0,0,0,1.567,1.567h1.567a1.567,1.567,0,0,0,1.567-1.567V15.571h7.052A1.567,1.567,0,0,0,21.94,14V12.436A1.567,1.567,0,0,0,20.373,10.869Z",
    transform: "translate(0 -2.25)",
    fill: "#40eefe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostPlus);
export default __webpack_public_path__ + "static/media/post-plus.5102ac5043cf64f346446f1cf9f09ec2.svg";
export { ForwardRef as ReactComponent };